import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import "@fontsource-variable/inter";
import { Sidebar } from "./Sidebar";
import { MobileHeader } from "./MobileHeader";
import { MobileDrawer } from "./MobileDrawer";
import { usePageMeta } from "./usePageTitle";
import { Breadcrumbs } from "./Breadcrumbs";
import { VersionBadge } from "./VersionBadge";

export function AppLayout() {
	const [drawerOpen, setDrawerOpen] = useState(false);
	const location = useLocation();
	const {
		title: pageTitle,
		description: pageDescription,
		hideTitle = false
	} = usePageMeta();

	useEffect(() => {
		document.title =
			pageTitle === "Mee" || pageTitle === "Mee Admin"
				? "Mee - Admin"
				: `${pageTitle} | Mee - Admin`;
	}, [pageTitle]);

	// Use the /admin prefix + first two path segments as a key to force
	// remount when navigating between sibling routes (e.g.
	// /admin/operations/forms → /admin/operations/reports)
	const routeKey = location.pathname.split("/").slice(0, 4).join("/");

	// Hide all navigation when embedded in React Native WebView
	if (window.ReactNativeWebView) {
		return (
			<main className="min-h-screen font-admin">
				<Outlet />
			</main>
		);
	}

	return (
		<div className="min-h-screen bg-canvas font-admin">
			<a
				href="#main-content"
				className="sr-only focus:not-sr-only focus:absolute focus:z-50 focus:px-4 focus:py-2 focus:bg-primary focus:text-white focus:rounded-md focus:top-2 focus:left-2"
			>
				Skip to main content
			</a>
			<Sidebar />
			<MobileHeader onMenuClick={() => setDrawerOpen(true)} />
			<MobileDrawer open={drawerOpen} onOpenChange={setDrawerOpen} />
			{/* design-lint-allow: layout offset must exactly match Sidebar's fixed xl:w-[280px], not a spacing/rhythm value */}
			<main id="main-content" className="xl:pl-[280px]">
				<div className="mx-auto w-full max-w-7xl px-4 py-6 md:px-6">
					<Breadcrumbs />
					{/* Desktop page title (mobile title is in MobileHeader).
					    Routes can opt out via `hideTitle` in usePageTitle,
					    in which case they must render their own top-level
					    heading. */}
					{!hideTitle && (
						<>
							<h1 className="mb-1 hidden text-page-title xl:block">
								{pageTitle}
							</h1>
							{pageDescription && (
								<p className="text-page-sub mb-6">{pageDescription}</p>
							)}
						</>
					)}
					<Outlet key={routeKey} />
				</div>
			</main>
			<VersionBadge />
		</div>
	);
}
